import { Key } from "react";
import dayjs from "dayjs";
import { IGroupField } from "../SuperTable/interface";
import { DEFAULT_DATA_FORMAT, DETAULT_TIME_FORMAT, IMAGE_THUMB_NAME, STATUS_CREATED, STATUS_CREATED_CODE, TABLE_COLUMN_EMPTY } from "../constants/constant";
import { IObject, NamePath, addEdiTableProps, addEditVirtualTableProps, addMainSubTableProps, moneyProps } from "../constants/interface";
import { SuperFormItemProps } from "../SuperForm/interface";
import { InputNumberProps } from "antd/lib/input-number";
import { formtaFormItemName } from "../EditVirtualTable/utils";
import { responseError, responseSuccess } from "./messageUtils";
import { ADD_CHILDREN_KEY, EMPTY_CHILDREN_KEY } from "../EditMainSubTable/interface";

/**
 * 小数加法
 * @param data1
 * @param data2
 */
export const accAdd = (data1: number = 0, data2: number = 0) => {
  var r1, r2, m, c;
  try {
    r1 = data1.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = data2.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  c = Math.abs(r1 - r2);
  m = Math.pow(10, Math.max(r1, r2));
  if (c > 0) {
    var cm = Math.pow(10, c);
    if (r1 > r2) {
      data1 = Number(data1.toString().replace('.', ''));
      data2 = Number(data2.toString().replace('.', '')) * cm;
    } else {
      data1 = Number(data1.toString().replace('.', '')) * cm;
      data2 = Number(data2.toString().replace('.', ''));
    }
  } else {
    data1 = Number(data1.toString().replace('.', ''));
    data2 = Number(data2.toString().replace('.', ''));
  }
  return (data1 + data2) / m;
};
/**
 * 小数减法
 * @param data1
 * @param data2
 */
export const numSub = (num1: number, num2: number) => {
  var baseNum, baseNum1, baseNum2;
  var precision; // 精度
  try {
    baseNum1 = num1.toString().split('.')[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split('.')[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
  precision = baseNum1 >= baseNum2 ? baseNum1 : baseNum2;
  return ((num1 * baseNum - num2 * baseNum) / baseNum).toFixed(precision);
};
/***
 * 小数乘法
 */
export const accMulti = (data1: number, data2: number) => {
  var baseData = 0;
  try {
    baseData += data1.toString().split('.')[1].length;
  } catch (e) {}
  try {
    baseData += data2.toString().split('.')[1].length;
  } catch (e) {}
  return (
    (Number(data1.toString().replace('.', '')) *
      Number(data2.toString().replace('.', ''))) /
    Math.pow(10, baseData)
  );
};
/**
 * 小数除法
 */
export const accDiv = (arg1: number, arg2: number) => {
  let t1 = 0;
  let t2 = 0;
  let r1, r2;
  try {
    t1 = arg1.toString().split('.')[1].length;
  } catch (e) {}
  try {
    t2 = arg2.toString().split('.')[1].length;
  } catch (e) {}
  r1 = Number(arg1.toString().replace('.', ''));
  r2 = Number(arg2.toString().replace('.', ''));
  return (r1 / r2) * Math.pow(10, t2 - t1);
};
/**
 * 将图片路径转换成压缩图路径
 * @param path 图片路径
 * @returns
 */
export function getThumbUrl(path: string) {
  let thumbUrl = path;
  if (path?.includes?.(IMAGE_THUMB_NAME)) return path;
  if (/^(http(s)?:\/\/)/i.test(path)) {
    if (new RegExp(/(.*)([\.]\w*)$/).test(path)) {
      thumbUrl = path.replace(RegExp.$1, RegExp.$1 + IMAGE_THUMB_NAME);
    }
    return thumbUrl;
  }
  return thumbUrl;
}
/**
 * 字符串截取
 * @param str 字符串
 * @param maxLength 最大长度
 * @returns
 */
export function stringSubstr(
  str: string,
  maxLength: number = 10,
  ellipsis: string = '...',
) {
  if (str && str.length) {
    if (str.length > maxLength) return `${str.slice(0, maxLength)}${ellipsis}`;
    return str;
  }
  return str;
}
/**
 * 金额格式化
 * @param money 金额
 * @param configProps moneySymbol 金额前缀符号 decimals 小数点位数 decPoint 小数点符号 thousandsSep 千分位符号
 * @returns
 */
export function moneyFormat(
  money: number,
  configProps: moneyProps = {},
): string {
  if (!money && money !== 0) return TABLE_COLUMN_EMPTY;
  const {
    moneySymbol = '¥',
    decimals = 2,
    decPoint = '.',
    thousandsSep = ',',
  } = configProps;
  let num = Number(money);
  if (num > -0.005 && num < 0.005) num = 0;
  const moneyArray: string[] = num
    .toFixed(decimals)
    .toString()
    .split('.');
  const intFormat = moneyArray[0].replace(
    /(\d)(?=(?:\d{3})+$)/g,
    `$1${thousandsSep}`,
  );
  let result = `${moneySymbol}${intFormat}`;
  if (decimals && decPoint) {
    result = `${result}${decPoint}${moneyArray[1]}`;
  }
  return result;
}
/**
 * 格式化associateSelect类型表单参数
 * @param params 列表参数
 * @param associateSelectName associateSelect表单name
 */
export function formatAssociateParams(params: any, associateSelectName: string): any {
  if (!params) return {};
  const {[associateSelectName]: itemName, ...restParams} = params;
  if (Array.isArray(itemName) && itemName.length) {
    if (itemName.length === 2 && typeof itemName[0] === 'string' && typeof itemName[1] === 'string') {
      restParams[itemName[0]] = itemName[1];
    }
    itemName.forEach(item => {
      if (Array.isArray(item) && item.length === 2 && typeof item[0] === 'string' && typeof item[1] === 'string') {
        restParams[item[0]] = item[1];
      }
    });
  }
  return restParams;
}
/**
 * 拼接组合字段并移除原有字段
 * @param groupFields 组合字段集合
 * @param params 参数对象
 * @returns 
 */
export function formatGroupFields(groupFields: IGroupField[], params: any) {
  const newParams: any = {...params};
  groupFields.forEach(item => {
    const { nameKey, valueKey } = item;
    const nameStr = newParams[nameKey];
    const valueStr = newParams[valueKey];
    if (nameStr && (valueStr !== undefined || valueStr !== '')) {
      newParams[nameStr] = valueStr;
    }
    delete newParams[nameKey];
    delete newParams[valueKey];
  });
  return newParams;
}
/**
 * 数组对象分组
 * @param dataSource 数组 
 * @param groupFiled 分组字段名
 * @returns 
 */
export function arrayGroup(dataSource?: any[], groupFiled?: string | string[]) {
  const groupDataSource: any = {};
  if (Array.isArray(dataSource) && dataSource.length && groupFiled) {
    dataSource.forEach(item => {
      const groupKey = Array.isArray(groupFiled) ? JSON.stringify(getRecordFieldsValue(item, groupFiled)) : item[groupFiled];
      if (groupKey) {
        if (!groupDataSource[groupKey]) {
          groupDataSource[groupKey] = [];
        }
        groupDataSource[groupKey].push(item);
      }
    });
  }
  return groupDataSource;
}
/**
 * 提前当前对象的指定属性
 * @param record 数据对象
 * @param fieldnames 属性名称集合
 * @returns 
 */
function getRecordFieldsValue(record: any, fieldnames: string[]) {
  const values: any = {};
  fieldnames.forEach(item => {
    values[item] = record?.[item];
  });
  return values;
};
/**
 * 获取单元格数据里面子对象的数据
 * @param record 当前行数据
 * @param dataIndex 单元格字段
 */
export function getColumnValue(record: any, dataIndex?: any) {
  if (Array.isArray(dataIndex)) {
    return getFieldNamesData(record, dataIndex);
  }
  if (typeof dataIndex === 'string') {
    if (dataIndex?.includes('.')) {
      const fieldNames = dataIndex.split('.');
      return getFieldNamesData(record, fieldNames);
    }
    return record[dataIndex];
  }
  return record;
}
/**
 * 获取子属性的值
 * @param data 数据
 * @param fieldNames 子属性名称层级集合
 * @returns 
 */
export function getFieldNamesData(data: any, fieldNames: string[]) {
  const fieldLength = fieldNames.length;
  let fieldValue: any = undefined;
  for (let i = 0; i < fieldLength; i++) {
    const fieldName = fieldNames[i];
    fieldValue = i === 0 ? data?.[fieldName] : fieldValue?.[fieldName]
  }
  return fieldValue;
}
/**
 * 判断两个数组是否全等
 * @param arr1 数组1
 * @param arr2 数组2
 * @returns boolean
 */
export const arrayAllEqual = (arr1?: any[], arr2?: any[]): boolean => {
  if (Array.isArray(arr1) && Array.isArray(arr2)) {
    if (arr1.length === arr2.length) {
      for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) return false;
      }
      return true;
    }
    return false;
  }
  return arr1 === arr2;
};
/**
 * 拉平数组
 * @param arr
 * @param childrenKey
 */
export const flatArray = (
  arr: any[],
  childrenKey: string = 'children',
): any[] => {
  let result: any[] = [];
  arr.forEach(item => {
    result.push(item);
    const children = item[`${childrenKey}`];
    if (Array.isArray(children)) {
      result.push(...flatArray(children, childrenKey));
    }
  });
  return result;
};
/**
 * 拉平数组并过滤主表
 * @param arr
 * @param childrenKey
 */
export const flatChildrenArray = (
  arr: any[],
  childrenKey: string = 'children',
): any[] => {
  let result: any[] = [];
  arr.forEach(item => {
    const children = item[`${childrenKey}`];
    if (Array.isArray(children)) {
      result.push(...flatArray(children, childrenKey));
    }
  });
  return result;
};
/**
 * 将图片路径装换成原图路径
 * @param url 图片路径
 */
export function getImageOriginalUrl(url: string): string {
  let originalUrl: string = '';
  if (!url) return originalUrl;
  if (typeof url !== 'string') return originalUrl;
  const pathName = url.slice(0, url.lastIndexOf('.'));
  const suffix = url.slice(url.lastIndexOf('.'));
  originalUrl = pathName.endsWith(IMAGE_THUMB_NAME)
    ? pathName.slice(0, pathName.lastIndexOf(IMAGE_THUMB_NAME))
    : pathName;
  originalUrl += suffix;
  return originalUrl;
}
export function formDataToValues(
  formData: any,
  formItems: SuperFormItemProps[],
) {
  const result: any = {};
  for (let [key, value] of Object.entries(formData)) {
    const currentFormItem = formItems.find(v => {
      const formItemName = v.name;
      if (Array.isArray(formItemName)) {
        return formItemName.includes(key);
      }
      return formItemName === key;
    });
    if (currentFormItem) {
      if (
        currentFormItem.formItemType === 'DatePicker' &&
        dayjs.isDayjs(value)
      ) {
        const dataFormat: string = currentFormItem.datePickerProps
          ?.format as string;
        result[key] = value.format(dataFormat || DEFAULT_DATA_FORMAT);
      } else if (
        currentFormItem.formItemType === 'TimePicker' &&
        dayjs.isDayjs(value)
      ) {
        const dataFormat: string = currentFormItem.timePickerProps
          ?.format as string;
        result[key] = value.format(dataFormat || DETAULT_TIME_FORMAT);
      } else if (
        currentFormItem.formItemType === 'RangePicker' &&
        Array.isArray(value)
      ) {
        const dataFormat: string = currentFormItem.rangePickerProps
          ?.format as string;
        result[key] = value.map((v: any) => {
          if (dayjs.isDayjs(v)) {
            return v.format(dataFormat || DEFAULT_DATA_FORMAT);
          }
          return v;
        });
      } else if (
        currentFormItem.formItemType === 'TimeSlot' &&
        dayjs.isDayjs(value)
      ) {
        const dataFormat: string = currentFormItem.datePickerProps
          ?.format as string;
        result[key] = value.format(dataFormat || DEFAULT_DATA_FORMAT);
      } else {
        result[key] = value;
      }
    } else {
      result[key] = value;
    }
  }
  return result;
}
/**
 * 时间戳+随机数
 * @param maxRandom 最大随机数
 * @returns
 */
export function getTimeRandom(maxRandom: number = 1000) {
  const timeNum: number = new Date().getTime();
  const randomNum: number = Math.floor(Math.random() * maxRandom);
  return `${timeNum}-${randomNum}`;
}
/**
 * 判断两个数组是否相等
 * @param arr1 数组1
 * @param arr2 数组2
 * @returns boolean
 */
export const arrayEqual = (arr1?: NamePath, arr2?: NamePath): boolean => {
  if (Array.isArray(arr1) && Array.isArray(arr2)) {
    if (arr1.length === arr2.length) {
      for (let i = 0; i < arr1.length; i++) {
        const element = arr1[i];
        if (!arr2.includes(element)) return false;
      }
      return true;
    }
    return false;
  }
  return arr1 === arr2;
};
/**
 * InputNumber组件限制props
 * @param numberLength 数字最大长度（小数点除外）
 * @param decimalLength 小数部分长度
 * @returns InputNumberProps
 */
export function decimalInputNumber(
  numberLength: number,
  decimalLength: number = 2,
): InputNumberProps {
  const props: InputNumberProps = {
    min: 0,
    precision: decimalLength,
    maxLength: numberLength + 1,
  };
  const maxNumber: number = Number(
    '9'.padEnd(numberLength - decimalLength, '9'),
  );
  props.max = maxNumber;
  return props;
}
/**
 * 将列表的dataIndex转换成Form表单的name
 * @param rule 当前字段的rule
 * @param dataIndex 列表的dataIndex值
 */
export function getEditVirtualTableFormName(rule: any, dataIndex: string) {
  const fieldName: string = rule?.field;
  if (!fieldName) return dataIndex;
  const ruleName = formtaFormItemName(fieldName);
  return `${dataIndex}-${ruleName.key}`;
}
/**
 * 生成自然数排序的数组
 * @param length 长度
 * @param startNumber 开始值
 */
export function getNumberSortArray(
  length: number,
  startNumber: number = 0,
): number[] {
  if (length <= 0) return [];
  return Array.from({ length }).map((v, index) => index + startNumber);
}
/**
 * 下载文件
 * @param downApi 接口阿皮 
 * @param params 参数
 * @param fileName 文件名
 * @returns 
 */
export const downloadFile = async (downApi: (params?: any) => Promise<any>, params?: any, fileName?: string) => {
  const downloadRes = await downApi(params);
  if (!downloadRes || downloadRes?.code) {
    responseError('下载失败');
    return;
  }
  const blob = new Blob([downloadRes.data], {type: downloadRes.headers['content-type']});
  // 文件不存在，类型为application/json
  if (blob.type.includes('application/json')) {
    const reader = new FileReader();
    reader.readAsText(blob, 'utf8');
    reader.onload = function() {
      // blob解析出来的数据
      const content = this.result;
      if (typeof content === 'string') {
        try {
          const errorJson = JSON.parse(content);
          responseError(errorJson.message || '下载失败');
        } catch (errorInfo: any) {
          console.error('无法解析下载失败原因');
        }
      }
    }
    return;
  };
  let url = window.URL.createObjectURL(blob);
  var a = document.createElement('a');
  document.body.appendChild(a);
  a.href = url;
  if (fileName) {
    a.download = fileName;
  } else {
    const disposition = decodeURI(
      downloadRes.headers.get('content-disposition') ?? '',
    );
    const headerFileName: string = disposition.split('filename=')[1] ?? '';
    a.download = headerFileName;
  }
  a.click(); // 模拟点击下载
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
  responseSuccess('下载成功');
};
/**
 * 通过远程URL下载文件
 * @param url 文件url
 * @param fileName 文件名称
 * @returns
 */
export const urlDownloadFile = (url: string, fileName?: string) => {
  if (!url) return;
  const aElement = document.createElement('a');
  document.body.appendChild(aElement);
  aElement.href = url;
  aElement.download = fileName || '';
  aElement.click();
  document.body.removeChild(aElement);
};
/**
 * 删除数组的某个元素
 * @param arr 数组
 * @param deleteItem 要删除的项
 */
export const deleteArrayItem = (arr: any[], deleteItem: any): any[] => {
  const result: any[] = [...arr];
  const findItem = result.findIndex(v => v === deleteItem);
  if (findItem > -1) result.splice(findItem, 1);
  return result;
};
/**
 * 数组arr1是否包含数组arr2
 * @param arr1 数组
 * @param arr2 被包含数组
 */
export const includeArray = (arr1: any[], arr2: any[]): boolean => {
  if (!arr1 || !arr1.length) return false;
  if (!arr2 || !arr2.length) return false;
  for (let i = 0; i < arr2.length; i++) {
    if (!arr1.includes(arr2[i])) return false;
  }
  return true;
};
/** 判断是否为长度不为零的数组 */
export function isEffectiveArray(arr: any): boolean {
  return Array.isArray(arr) && !!arr.length;
}
/**
 * 生成编辑后的状态
 * @param recordStatus 原状态
 * @returns 
 */
export function getEditUpdataStatus(recordStatus: any) {
  if (recordStatus === STATUS_CREATED.ADD) return STATUS_CREATED.ADD;
  return STATUS_CREATED.UPDATE;
}
/**
 * 验证可编辑表数据
 * @param dataSource 可编辑表数据
 * @returns any[] | false
 */
export function verificationListEffective(dataSource: any): any[] | false {
  if (Array.isArray(dataSource) && dataSource.length) {
    const effectiveList: any[] = dataSource.filter(item => {
      return item[STATUS_CREATED_CODE] !== STATUS_CREATED.DELETE;
    });
    return effectiveList.length ? effectiveList : false;
  }
  return false;
}
/**
 * 获取图片相对路径
 * @param imageUrl 完整路径
 * @returns
 */
export function getRelativePath(imageUrl?: string) {
  if (!imageUrl) return imageUrl;
  if (/^(http(s)?:\/\/)/i.test(imageUrl)) {
    try {
      const url = new URL(imageUrl);
      return url.pathname;
    } catch {
      return '';
    }
  }
  return imageUrl;
}
/**
 * 将url或者url数组转换成上传组件接收格式
 * @param url url或者url数组
 * @returns
 */
export function toUploadImagesData(url: string | string[]) {
  let result: any[] = [];
  if (Array.isArray(url)) {
    result = url.map((v, i) => ({
      uid: i,
      status: 'done',
      url: v,
      thumbUrl: getThumbUrl(v),
    }));
  } else {
    result.push({
      uid: -1,
      status: 'done',
      url: url,
      thumbUrl: getThumbUrl(url),
    });
  }
  return result;
}
/**
 * 判断变量是否为字符串且不为空
 * @param str 变量
 * @returns
 */
export function isString(str: any): boolean {
  return typeof str === 'string' && str !== '';
}
/**
 * 判断是否为数组且不为空
 * @param arr 变量
 * @returns
 */
export function isArray(arr: any): boolean {
  return Array.isArray(arr) && !!arr.length;
}
/**
 * 判断是否为数字
 * @param num 变量
 * @returns
 */
export function isNumber(num: any) {
  return typeof num === 'number';
}
/**
 * 去除数组重复成员（只支持字符串和数字的数组）
 * @param arr 数组
 * @returns
 */
export function dedupe(arr: Key[]): Key[] {
  return Array.from(new Set(arr));
}
/**
 * 生成最大值
 * @param num
 * @param integerLength
 * @param decimalLength
 * @returns
 */
export const formatNumber = (
  num: number | string,
  integerLength: number,
  decimalLength: number,
) => {
  const maxLength: number = integerLength + decimalLength + 1;
  let numStr: string = typeof num === 'number' ? num.toString() : num;
  if (numStr.length <= integerLength)
    return Number(numStr).toFixed(decimalLength);
  const numArr = /^(\d+)(\.\d*)?$/.exec(numStr);
  if (Array.isArray(numArr) && numArr.length === 3) {
    const integerStr: string = numArr[1];
    if (integerStr.length <= integerLength)
      return Number(numStr).toFixed(decimalLength);
    const maxNum = ''.padStart(integerLength, '9');
    const decimalNum = ''.padStart(decimalLength, '9');
    return Number(`${maxNum}.${decimalNum}`).toFixed(decimalLength);
  }
};
export function getRecordKey(record: any, key: string | string[]) {
  let recordKey: string = '';
  if (!record || !key) return recordKey;
  if (Array.isArray(key)) {
    key.forEach(item => {
      recordKey = recordKey + (record[item] ?? '');
    })
  } else {
    recordKey = record[key];
  }
  return recordKey;
};
/**
 * 过滤后需要添加的可编辑数据
 * @param oldData 
 * @param addData 
 */
export function filterHaveData(oldData: any[] = [], addData: any[], rowKey: string | string[]): any[] {
  if (!addData || !addData.length) {
    return [];
  }
  const newData: any[] = [];
  if (!oldData || !oldData.length) {
    return addData;
  }
  const effectiveData = oldData.filter(item => item[STATUS_CREATED_CODE] !== STATUS_CREATED.DELETE);
  if (!effectiveData.length) {
    return addData;
  }
  addData.forEach(item => {
    const findItem = effectiveData.find(v => getRecordKey(v, rowKey) === getRecordKey(item, rowKey));
    if (!findItem) {
      newData.push(item);
    }
  });
  return newData;
}
/**
 * 验证下拉框是否有已选中的值
 * @param selectedValue 下拉框已选值
 */
export function validateNoSelectedValue(selectedValue: any): boolean {
  if (selectedValue === undefined || selectedValue === null) return false;
  if (Array.isArray(selectedValue) && !selectedValue.length) return false;
  return true;
}
/**
 * scv下载
 * @param csvData scv数据字符串
 * @param fieldName 文件名
 * @param suffixTime 文件名后添加时间后缀
 */
export function downloadCsv(csvData: string, fieldName?: string, suffixTime: string | false = 'YYYY-MM-DD') {
  let uri = "data:text/csv;charset=utf-8,\ufeff" + encodeURIComponent(csvData);
  const link = document.createElement("a");
  link.href = uri;
  let csvName: string = fieldName ?? '';
  if (suffixTime) {
    csvName += ` ${dayjs().format(suffixTime)}`;
  }
  link.download = `${csvName}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
/**
 * 商品列表转换成主子表格式
 * @param goodList 商品列表
 * @param isAdd 是否为新增模式
 */
export function goodListGroup(goodList: any, isAdd: boolean = false): any[] {
  const mainDataSource: any[] = [];
  if (Array.isArray(goodList) && goodList.length) {
    const productGroup: any = {};
    goodList.forEach(item => {
      const { bskuId } = item;
      if (bskuId) {
        if (!productGroup[bskuId]) productGroup[bskuId] = [];
        productGroup[bskuId].push(item);
      }
    });
    const values: any[] = Object.values(productGroup);
    values.forEach(item => {
      if (Array.isArray(item) && item.length) {
        const firstChildren = item[0];
        const mainSkuInfo = firstChildren.skuInfo;
        mainDataSource.push({
          ...mainSkuInfo,
          [STATUS_CREATED_CODE]: isAdd ? STATUS_CREATED.ADD : STATUS_CREATED.DEFAULT,
          children: item.map(record => {
            const { skuInfo, ...restRecord } = record;
            return {
              ...restRecord,
              trackingState: skuInfo.trackingState,
              trackingType: skuInfo.trackingType,
              periodValidityState: skuInfo.periodValidityState,
              periodEffect: skuInfo.periodEffect,
              [STATUS_CREATED_CODE]: isAdd ? STATUS_CREATED.ADD : STATUS_CREATED.DEFAULT,
            };
          }),
        });
      }
    });
  }
  return mainDataSource;
}
/**
 * 格式化tootip提示内容
 * @param title tootip提示内容
 * @returns 
 */
export function formatTootipTitle(title: any) {
  if (typeof title === 'string' && !!title) return title;
}
/**
 * dataSource分类  (已删除，未删除)
 * @param dataSource 
 */
export function dataSourceClassification(dataSource?: any[]): {
  /** 有效数据 */
  effectiveDataSource: any[];
  /** 已删除数据 */
  deleteDataSource: any[];
} {
  /** 有效数据 */
  const effectiveDataSource: any[] = [];
  /** 已删除数据 */
  const deleteDataSource: any[] = [];
  if (Array.isArray(dataSource) && dataSource.length) {
    dataSource.forEach(item => {
      if (item[STATUS_CREATED_CODE] === STATUS_CREATED.DELETE) {
        deleteDataSource.push(item);
      } else {
        effectiveDataSource.push(item);
      }
    });
  }
  return {
    effectiveDataSource,
    deleteDataSource,
  };
}
/**
 * 过滤出对象中的一个字段或集合
 * @param record 对象
 * @param filednames 字段或集合
 * @returns 
 */
export function filterObjectFilednames(record: any, filednames?: string | string[]) {
  if (!record || !filednames) return {};
  if (typeof filednames === 'string') {
    return filterObjectFiledname(record, filednames);
  }
  if (Array.isArray(filednames) && filednames.length) {
    const result: any = {};
    filednames.forEach(item => {
      const fieldValue = record[item];
      if (fieldValue === undefined || fieldValue === null || fieldValue === '') {
        return;
      }
      result[item] = fieldValue;
    });
    return result;
  }
  return {};
}
/**
 * 过滤出对象中的一个字段
 * @param record 对象
 * @param filename 字段名称
 * @returns 
 */
export function filterObjectFiledname(record: any, filedname?: string) {
  if (!record || !filedname) return {};
  const fieldValue = record[filedname];
  if (fieldValue === undefined || fieldValue === null || fieldValue === '') return {};
  return { [filedname]: fieldValue, };
}
/**
 * 返回一个数组（如果传入的数据是一个数组则返回原数组，反之返回一个空数组）
 * @param data 传入数据
 * @returns 
 */
export function returnArray(data: any): any[] {
  if (Array.isArray(data)) return data;
  return [];
}
